import { Button, Select } from 'antd'
import { StarFilled } from '@ant-design/icons'

const TurnSetter = ({ defaultTurn, setTurn, matchTurn, firstTurnName = undefined, now_turn = undefined }) => {
  let array = [['sum', firstTurnName], ...[...Array(matchTurn)].map((_, index) => [index + 1, `第${index + 1}轮`])]
  if (firstTurnName === undefined) {
    array = [...[...Array(matchTurn)].map((_, index) => [index + 1, `第${index + 1}轮`])]
  }
  const this_turn = defaultTurn <= 0 || !defaultTurn ? 1 : defaultTurn
  if (matchTurn <= 6)
    return (
      <>
        {array.map((t) => (
          <Button
            size="small"
            type={this_turn === t[0] ? 'primary' : 'link'}
            onClick={() => {
              setTurn(t[0])
            }}
            key={t[1]}
          >
            {now_turn === t[0] && <StarFilled />}
            {t[1]}
          </Button>
        ))}
      </>
    )
  return (
    <div className="flex items-center">
      <Select
        className="h-7 w-28"
        value={this_turn}
        onChange={(e) => {
          let thisTurn = e
          if (e !== 'sum') {
            thisTurn = parseInt(e, 10)
          }
          setTurn(thisTurn)
        }}
      >
        {array.map((t) => (
          <Select.Option key={t[0]} label={t[1]} value={t[0]}>
            <span className="flex w-full justify-center">
              {now_turn === t[0] && <StarFilled />}
              {t[1]}
            </span>
          </Select.Option>
        ))}
      </Select>
    </div>
  )
}

export default TurnSetter
